import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiPut } from 'app/shared-components/util/restAPI';

export const searchHelp = createAsyncThunk(
  'helpPanel/searchHelp',
  async ({ query, tag, limit = 50, offset = 0, aiSummary = false }) => {
    const response = await apiPut('CoreAPI', '/search/help', {
      body: { keywords: query, tags: tag ? [tag] : null, limit, offset, aiSummary }
    });
    return response;
  }
);

const helpPanelSlice = createSlice({
  name: 'helpPanel',
  initialState: {
    open: false,
    mode: 'context', // 'context' or 'search'
    searchText: '',
    contextConfig: null, // {query, tag, title}
    results: [],
    aiSummary: null,
    loading: false,
    selectedGuide: null
  },
  reducers: {
    openHelpPanel: (state, action) => {
      state.open = true;
      state.mode = 'context';
      state.contextConfig = action.payload;
      state.searchText = '';
    },
    closeHelpPanel: (state) => {
      state.open = false;
      state.searchText = '';
      state.results = [];
      state.aiSummary = null;
    },
    setSearchText: (state, action) => {
      state.searchText = action.payload;
      state.mode = action.payload ? 'search' : 'context';
    },
    clearSearch: (state) => {
      state.searchText = '';
      state.mode = 'context';
    },
    selectGuide: (state, action) => {
      state.selectedGuide = action.payload;
    },
    closeGuide: (state) => {
      state.selectedGuide = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchHelp.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchHelp.fulfilled, (state, action) => {
        state.loading = false;
        // Handle new response structure with results and aiSummary
        if (action.payload.results) {
          state.results = action.payload.results;
          state.aiSummary = action.payload.aiSummary || null;
        } else {
          // Backward compatibility if response is just an array
          state.results = action.payload;
          state.aiSummary = null;
        }
      })
      .addCase(searchHelp.rejected, (state) => {
        state.loading = false;
        state.results = [];
        state.aiSummary = null;
      });
  }
});

export const {
  openHelpPanel,
  closeHelpPanel,
  setSearchText,
  clearSearch,
  selectGuide,
  closeGuide
} = helpPanelSlice.actions;

export const selectHelpPanelOpen = ({ helpPanel }) => helpPanel.open;
export const selectHelpPanelMode = ({ helpPanel }) => helpPanel.mode;
export const selectHelpPanelSearchText = ({ helpPanel }) => helpPanel.searchText;
export const selectHelpPanelContextConfig = ({ helpPanel }) => helpPanel.contextConfig;
export const selectHelpPanelResults = ({ helpPanel }) => helpPanel.results;
export const selectHelpPanelAiSummary = ({ helpPanel }) => helpPanel.aiSummary;
export const selectHelpPanelLoading = ({ helpPanel }) => helpPanel.loading;
export const selectSelectedGuide = ({ helpPanel }) => helpPanel.selectedGuide;

export default helpPanelSlice.reducer;
